/**
 * Standalone Outlook Add-in Logout Page
 *
 * This is NOT an Angular component — it is a plain TypeScript function that
 * renders a self-contained logout page via document.write() BEFORE Angular
 * bootstraps. This prevents AuthService from initialising and crashing when
 * localStorage is already empty after logout.
 *
 * Flow:
 *   main.ts detects /addin-logout → calls renderAddinLogout()
 *   → localStorage + sessionStorage cleared
 *   → countdown page rendered (5 s)
 *   → Office.context.ui.messageParent('CLOSE') sent to Outlook
 *   → Outlook dialog closes
 */

export function renderAddinLogout(): void {
  localStorage.clear();
  sessionStorage.clear();

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Signed Out - T2</title>
  <style>
    *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      background-image: url('../../../../assets/images/bglogin2.jpg');
      background-size: cover;
      background-position: center center;
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
    }

    .logout-card {
      background: rgba(0,0,0,0.6);
      border-radius: 16px;
      padding: 48px 40px;
      text-align: center;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
      max-width: 420px;
      width: 90%;
      color: #ffffff;
    }

    .logout-icon {
      width: 68px;
      height: 68px;
      background: #000000;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 20px;
      font-size: 30px;
      color: #ffffff;
    }

    .logout-title {
      font-size: 22px;
      font-weight: 700;
      color: #ffffff;
      margin-bottom: 8px;
    }

    .logout-subtitle {
      color: #ffffff;
      font-size: 14px;
      margin-bottom: 28px;
      opacity: 0.9;
    }

    /* Countdown ring */
    .countdown-ring {
      width: 110px;
      height: 110px;
      margin: 0 auto 12px;
      position: relative;
    }

    .countdown-ring svg {
      transform: rotate(-90deg);
    }

    .countdown-ring circle {
      fill: none;
      stroke-width: 5;
    }

    .ring-track  { stroke: rgba(255,255,255,0.18); }
    .ring-fill   { stroke: #FFA500; stroke-linecap: round; transition: stroke-dashoffset 1s linear; }

    .countdown-number {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 30px;
      font-weight: 700;
      color: #ffffff;
    }

    .countdown-label {
      color: rgba(255,255,255,0.85);
      font-size: 12px;
      margin-bottom: 28px;
    }

    .close-btn {
      background: #FFA500;
      color: #ffffff;
      border: none;
      padding: 13px 36px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: opacity 0.15s ease-in-out;
    }

    .close-btn:hover { opacity: 0.88; }
  </style>
</head>
<body>
  <div class="logout-card">
    <div class="logout-icon">&#10003;</div>
    <h1 class="logout-title">You've Been Signed Out</h1>
    <p class="logout-subtitle">Your session has been cleared successfully.</p>

    <div class="countdown-ring">
      <svg width="110" height="110">
        <circle class="ring-track" cx="55" cy="55" r="48"></circle>
        <circle class="ring-fill" id="ring-fill" cx="55" cy="55" r="48"
          stroke-dasharray="301.6" stroke-dashoffset="0"></circle>
      </svg>
      <div class="countdown-number" id="countdown-number">5</div>
    </div>

    <p class="countdown-label">This window will close automatically</p>
    <button class="close-btn" id="close-btn">Close Now</button>
  </div>

  <script src="https://appsforoffice.microsoft.com/lib/1/hosted/office.js"></script>
  <script>
    var seconds = 5;
    var ringFill = document.getElementById('ring-fill');
    var countdownNumber = document.getElementById('countdown-number');
    var circumference = 301.6;

    function closeDialog() {
      try { Office.context.ui.messageParent('CLOSE'); } catch (e) { /* not in dialog */ }
      try { window.close(); } catch (e) { /* ignore */ }
    }

    document.getElementById('close-btn').addEventListener('click', closeDialog);

    var timer = setInterval(function () {
      seconds--;
      countdownNumber.textContent = seconds;
      ringFill.style.strokeDashoffset = circumference * (1 - seconds / 5);
      if (seconds <= 0) {
        clearInterval(timer);
        closeDialog();
      }
    }, 1000);
  </script>
</body>
</html>`;

  document.open();
  document.write(html);
  document.close();
}
